/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  getSSOLink(apiAccessToken = '') {
    const headers = {};
    if (apiAccessToken) {
      headers.api_access_token = apiAccessToken;
      headers.Content_Type = 'application/json';
    }

    return axios.get(`${this.apiVersion}/profile/login`, {
      headers,
    });
  }
}

export default new AccountAPI();
